import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navigation from '../components/feature/Navigation';
import Footer from '../components/feature/Footer';
import { pathFor } from '../router/paths';

export default function NotFound() {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const lang = i18n.language === 'en' ? 'en' : 'de';

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navigation solid />

      <div className="relative flex-1 flex flex-col items-center justify-center text-center px-4 py-24">
      {/* Rein dekorativ - bewusst keine Ueberschrift, damit die Seite genau eine Hauptueberschrift hat. */}
      <div aria-hidden="true" className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </div>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">{t('notFoundTitle')}</h1>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-gray-500 max-w-xl mx-auto">{t('notFoundLead')}</p>

        {/* Echte <a href>-Links (react-router <Link>), damit Suchmaschinen ihnen folgen koennen. */}
        <p className="mt-8 text-sm text-gray-500">{t('notFoundLinksIntro')}</p>
        <div className="mt-3 flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          <Link
            to={pathFor('rooms', lang)}
            className="text-amber-700 underline underline-offset-4 hover:text-amber-600 transition-colors"
          >
            {t('notFoundLinkRooms')}
          </Link>
          <Link
            to={pathFor('buchen', lang)}
            className="text-amber-700 underline underline-offset-4 hover:text-amber-600 transition-colors"
          >
            {t('notFoundLinkBooking')}
          </Link>
        </div>

        <Link
          to={pathFor('home', lang)}
          className="mt-8 inline-flex items-center gap-2 bg-amber-700 text-white px-6 py-2.5 rounded-md text-sm font-medium hover:bg-amber-600 transition-colors cursor-pointer"
        >
          {t('notFoundCta')}
        </Link>
      </div>
      </div>

      <Footer />
    </div>
  );
}
